import {Component, Inject, OnInit} from '@angular/core';
import {WarehouseProduct} from "../../../shared/interface/warehouse-product";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface WarehouseProductAddDialogData {
  warehouseProduct?: WarehouseProduct;
}

@Component({
  selector: 'app-warehouse-product-purchase-add-dialog',
  templateUrl: './warehouse-product-purchase-add-dialog.component.html',
  styleUrls: ['./warehouse-product-purchase-add-dialog.component.scss']
})
export class WarehouseProductPurchaseAddDialogComponent implements OnInit {
  warehouseProductObject?: WarehouseProduct = null;

  constructor(
    public dialogRef: MatDialogRef<WarehouseProductPurchaseAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WarehouseProductAddDialogData
  ) {
    this.warehouseProductObject = data?.warehouseProduct;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
